var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"alert alert-danger\" role=\"alert\" ng-repeat=\"i in errors\" ng-if=\"$first\"><button type=\"button\" class=\"close\" ng-click=\"clear()\" data-dismiss=\"alert\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><p ng-if=\"::!hideTitle && title\">{{title}}</p><ul ng-repeat=\"g in errors\" class=\"list-unstyled\"><li ng-repeat=\"e in g\" ng-bind-html=\"::e.message\"></li></ul></div>";
var id1="validation-summary.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;